// src/app/google-analytics.service.ts
import { Injectable } from '@angular/core';

declare global {
    interface Window { dataLayer: any[]; }
}
declare function gtag(...args: any[]): void;

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
    public pageView(url: string) {
        gtag('config', 'G-TPYPHW3F0X', {
            page_path: url
        });
    }

    public event(eventName: string, params: Record<string, any>) {
        gtag('event', eventName, params);
    }
}
